import Vue from 'vue'
import VueRouter from 'vue-router'
import Pruebas from '../views/Pruebas.vue'
import Dynamic from '../views/Dynamic'





//import {SUPPORTED_LOCALES} from "../locale";

Vue.use(VueRouter)

/*function getLocaleRegex() {
  let reg = ''
  SUPPORTED_LOCALES.forEach((locale, index) => {
    reg = `${reg}${locale.code}${index !== SUPPORTED_LOCALES.length - 1 ? '|' : ''}`
  })
  return `(${reg})`
}*/

/*function getLocale(locale = 'en') {
  return SUPPORTED_LOCALES.find(loc => loc.code === locale);
}*/


const routes = [
  {
    path: '/static',
    name: 'Static',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Static.vue')
  },{
    path: '/',
    redirect: '/'+process.env.VUE_APP_PAIS_DEFECTO+'/'+navigator.language.split('-')[0],
    name: 'home'
  },
  {
    path: `/:pais/:locale/`,
    name: 'Home',
    component: Dynamic,
    props: true,
    children: [
      {
        path: 'sc/:hash/budget',
        name: 'ModeloSCSolicitar',
        props: true,
        component: Dynamic
      },
      {
        path: 'sc/:hash',
        name: 'ModeloSC',
        props: true,
        component: Dynamic
      },
      {
        path: ':sku',
        name: 'Modelo',
        props: true,
        component: Dynamic
      },

    ]

  },
  {
    path: '/pruebas',
    name: 'Pruebas',
    component: Pruebas
  },
  {
    path: '/dynamic-old',
    name: 'DynamicOld',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DynamicOld.vue')
  },
  {
    path: '/dynamic',
    name: 'Dynamic',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Dynamic.vue')
  }
]

const router = new VueRouter({
  mode:'history',
  hash: false,
  base: process.env.BASE_URL,
  routes
})

export default router
